// Tracks recently-viewed leads in localStorage (most-recent first, max 8).
const KEY = 'recentLeads';

export const getRecent = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
  catch { return []; }
};

export const pushRecent = (item) => {
  if (!item || !item.id) return;
  const list = getRecent().filter((x) => x.id !== item.id);
  list.unshift({ id: item.id, name: item.name, sub: item.sub || '' });
  localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));
};
